// extracted by mini-css-extract-plugin
export default {"WeakSelect":"WeakSelect_WeakSelect__DC85M","selected":"WeakSelect_selected__QVdWw"};